import { MenuItemProps } from 'react-pro-sidebar';
import styled from 'styled-components';
import { SidebarMenuItem } from './index';

export interface SidebarItemProps {
  isButton?: boolean;
}

const SidebarMenuItemWrapper = styled.div<{ isButton?: boolean, disabled?: boolean }>`
  ${({ isButton, theme }) => (isButton ? `
    color: ${theme.colours.primary[1]};
    font-weight: ${theme.fontWeight.bold};
  ` : '')}

  ${({ theme, disabled }) => (disabled ? `
    cursor: default;
    opacity: 0.5;
    color: ${theme.colours.neutral[5]} !important;
  ` : '')}
`;

export function SidebarItem({
  children, icon, onClick, active = false, isButton = false, disabled = false, suffix,
}: (MenuItemProps & SidebarItemProps)) {
  return (
    <SidebarMenuItem
      disabled={disabled}
      icon={icon}
      suffix={suffix}
      active={active}
      onClick={onClick}
    >
      <SidebarMenuItemWrapper isButton={isButton} disabled={disabled}>
        {children}
      </SidebarMenuItemWrapper>
    </SidebarMenuItem>
  );
}
